// extracted by mini-css-extract-plugin
export var button = "_e3-4";
export var hasDarkBackground = "_e3-7";
export var hasLightBackground = "_e3-6";
export var iconWrapper = "_e3-0";
export var large = "_e3-2";
export var medium = "_e3-1";
export var small = "_e3-5";
export var xsmall = "_e3-3";